import * as React from 'react';
import { useEffect, useState } from 'react';
import BentoBox from '../BentoBox';
import { BentoBox as BentoBoxType } from 'types/generated';
import { fetchBentoBox } from '@/clients/BentoBoxUtils';

interface BentoBoxId {
  data: {
    cardHeight?: string;
    cardWidth?: string;
    items: {
      sys: {
        id: string;
      };
    }[];
  };
}

const LayoutOne = (data: BentoBoxId) => {
  const bentoBoxId = data.data.items[0]?.sys?.id;
  const [bentoBox, setBentoBox] = useState<BentoBoxType>({} as BentoBoxType);

  useEffect(() => {
    const fetchBox = async () => {
      if (bentoBoxId) {
        const box = await fetchBentoBox(bentoBoxId);
        if (box) {
          setBentoBox(box);
        }
      }
    };
    fetchBox();
  }, [bentoBoxId]);

  if (!bentoBox) {
    return <p>Loading bento box...</p>;
  }

  const { cardHeight, cardWidth } = data.data;

  if (cardHeight && cardWidth) {
    const aspectRatio = parseInt(cardWidth) / parseInt(cardHeight);

    return (
      <div
        className="w-full"
        style={{
          aspectRatio: `${aspectRatio}`,
          borderRadius: '24px',
          overflow: 'hidden',
        }}
      >
        <BentoBox box={bentoBox} />
      </div>
    );
  }

  return (
    <div style={{ width: '100%', minHeight: '70vh' }}>
      <BentoBox box={bentoBox} />
    </div>
  );
};

export default LayoutOne;
